import { Box, Button, TextField, Typography } from "@mui/material";

export default function SearchBox({
  colors,
  placeholder,
  searchInput,
  onSearchInputChange,
  activeSearch,
  onActiveSearchChange,
  minSearchLength = 3,
  onSearch,
  onClear,
  rightContent,
}) {
  const trimmedSearchInput = searchInput.trim();
  const shouldShowMinCharsHelper =
    trimmedSearchInput.length > 0 &&
    trimmedSearchInput.length < minSearchLength;

  const handleInputChange = (e) => {
    onSearchInputChange(e.target.value);
  };

  const handleSearchClick = () => {
    const q = trimmedSearchInput;
    onSearch?.(q);
    onActiveSearchChange(q.length >= minSearchLength ? q : "");
  };

  const handleClearClick = () => {
    onClear?.();
    onSearchInputChange("");
    onActiveSearchChange("");
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
        <Box display="flex" alignItems="center" gap={1}>
          <TextField
            size="small"
            placeholder={placeholder}
            value={searchInput}
            onChange={handleInputChange}
            sx={{
              width: 220,
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.common_white,
                borderRadius: "8px",
                height: "32px",
              },
              "& .MuiOutlinedInput-input::placeholder": {
                fontSize: "12px",
              },
            }}
          />
          <Button
            variant="text"
            onClick={handleSearchClick}
            disabled={shouldShowMinCharsHelper}
            sx={{
              height: "32px",
              minWidth: "auto",
              px: 0.75,
              textTransform: "none",
              color: colors.text_primary,
            }}
          >
            Search
          </Button>
          {activeSearch && (
            <Button
              variant="text"
              onClick={handleClearClick}
              sx={{
                height: "32px",
                minWidth: "auto",
                px: 0.75,
                textTransform: "none",
                color: colors.text_primary,
              }}
            >
              Clear
            </Button>
          )}
        </Box>
        {rightContent}
      </Box>
      {shouldShowMinCharsHelper && (
        <Typography
          variant="caption"
          sx={{ color: colors.text_secondary, mt: 1 }}
        >
          Minimum {minSearchLength} characters
        </Typography>
      )}
    </Box>
  );
}
